

/**
 * backOrderDate returns backorder date if product inventory status is BACKORDER.
 * @param {import('./').Product} product
 * @param {*} product
 * @returns {number}
 */
function backOrderDate(product) {
  if (product.inventoryProperties && Object.hasOwnProperty.call(product.inventoryProperties, 'expectedBackOrderAvailabilityDate')) {
    return product.inventoryProperties.expectedBackOrderAvailabilityDate;
  }

  return 0;
}


module.exports = backOrderDate;